import alertCircle from '../../../assets/images/alert_circle.svg'
import logo from '../../../assets/images/logo.png'
import mouseLeftEar from '../../../assets/images/mouse/left_ear.png'
import mouseRightEar from '../../../assets/images/mouse/right_ear.png'
import mouseHead from '../../../assets/images/mouse/head.png'

export const images = {
  alertCircle,
  logo,
  logoIco: logo,
  loading: logo,
  favicon: logo,
  mouseLeftEar,
  mouseRightEar,
  mouseHead,
  testImage:
    'https://images.unsplash.com/photo-1537815749002-de6a533c64db?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=845&q=80',
}
